import { run } from '../Cargo.toml'

run()